import advertApi from '@/api/advert';
import store from "@/store";

const state = {
    homeCompanyUrl: '',
    registerUrl: '',
    forgetPwdUrl: '',
};

const actions = {
    loadHomeCompanyUrl({ commit }) {
        let companyId = store.getters['advancedSearch/companyId'];
        advertApi.homeCompanyUrl(companyId,(homeCompanyUrl) => {
            commit('setHomeCompanyUrl', { homeCompanyUrl });
        });
    },
    loadRegisterUrl({ commit }) {
        let companyId = store.getters['advancedSearch/companyId'];
        advertApi.registerUrl(companyId, (registerUrl) => {
            commit('setRegisterUrl', { registerUrl });
        });
    },
    loadForgetPwdUrl({ commit }) {
        let companyId = store.getters['advancedSearch/companyId'];
        advertApi.forgetPwdUrl(companyId, (forgetPwdUrl) => {
            commit('setForgetPwdUrl', { forgetPwdUrl });
        });
    },
};

const mutations = {
    setHomeCompanyUrl(state, { homeCompanyUrl }) {
        state.homeCompanyUrl = homeCompanyUrl;
    },
    setRegisterUrl(state, { registerUrl }) {
        state.registerUrl = registerUrl;
    },
    setForgetPwdUrl(state, { forgetPwdUrl }) {
        state.forgetPwdUrl = forgetPwdUrl;
    }
};

const getters = {
    homeCompanyUrl(state) {
        return state.homeCompanyUrl;
    },
    registerUrl(state) {
        return state.registerUrl;
    },
    forgetPwdUrl(state) {
        return state.forgetPwdUrl;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
